module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"vk":{"copyright":"BONUS Vorsorgekasse AG"},"pk":{"copyright":"BONUS Pensionskassen Aktiengesellschaft"},"rak":{"copyright":"Concisa Vorsorgeberatung und Management AG"},"bpk":{"copyright":"Bundespensionskasse AG"},"wff":{"copyright":""}}}')
  delete Component.options._Ctor
}
